import { getBaseUrl } from '@plone/volto/helpers/Url/Url';

import {
  medicalFolderSegment,
  medicalServicesSegment,
} from './localizedSectionPath';

const quadreMedicFolderBasePath = (language) =>
  `/${language}/${medicalServicesSegment(language)}/${medicalFolderSegment('quadre-medic', language)}`;

const QUADRE_MEDIC_METGE_ROUTE =
  /^\/(ca|es|en)\/(serveis-medics|medical-services|servicios-medicos)\/(quadre-medic|medical-directory|cuadro-medico)\/([^/]+)$/;

/**
 * Parse quadre mèdic doctor detail URL (nonContentRoutes slug segment).
 * @returns {{ language: string, metgeSlug: string } | null}
 */
export function parseQuadreMedicMetgeRoute(pathname) {
  if (!pathname) {
    return null;
  }
  const path = pathname.split('?')[0];
  const match = path.match(QUADRE_MEDIC_METGE_ROUTE);
  if (!match) {
    return null;
  }
  return { language: match[1], metgeSlug: match[4] };
}

/**
 * Plone path for @breadcrumbs API. Doctor detail URLs map to the quadre-medic folder.
 */
export function getBreadcrumbApiPath(pathname) {
  if (!pathname) {
    return getBaseUrl(pathname);
  }
  const path = pathname.split('?')[0];
  const metgeRoute = parseQuadreMedicMetgeRoute(path);
  if (metgeRoute) {
    return quadreMedicFolderBasePath(metgeRoute.language);
  }
  return getBaseUrl(path);
}
